var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.68,31.84l3.54-3.6-5.5-5.5,5.5-5.5-3.54-3.6-9.1,9.1,9.1,9.1ZM28.81,31.84l9.1-9.1-9.1-9.1-3.54,3.6,5.5,5.5-5.5,5.5,3.54,3.6ZM5.05,45.48c-1.39,0-2.58-.49-3.57-1.48-.99-.99-1.48-2.18-1.48-3.57V5.05c0-1.39.49-2.58,1.48-3.57.99-.99,2.18-1.48,3.57-1.48h35.38c1.39,0,2.58.49,3.57,1.48s1.48,2.18,1.48,3.57v35.38c0,1.39-.49,2.58-1.48,3.57-.99.99-2.18,1.48-3.57,1.48H5.05ZM5.05,40.43h35.38V5.05H5.05v35.38ZM5.05,5.05v35.38V5.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/Developer.6838a1f4a50e77d4639ec08755846f5e.svg";
export { ForwardRef as ReactComponent };